import { render, staticRenderFns } from "./DefaultWebplayerLayout.vue?vue&type=template&id=7a20dc3c"
import script from "./DefaultWebplayerLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultWebplayerLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports